// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"78eba88a","266":"78eba88a","849":"9d065ee2","942":"420d24d9"}[chunkId] + ".chunk.css";
};